import {Grid2 as Grid, Paper, TableContainer, Table, TableHead, TableRow, TableCell, Typography, TableBody} from '@mui/material';
import changeLogCategory from '../../../types/reports/changeLogCategory';
import ChangeLogItem from '../../../types/reports/changeLogItem';
import { alpha, useTheme } from '@mui/material/styles';


interface Props {
   changes?:any;
}

export enum ChangeType {
    Unclear = 0,
    Add = 1,
    Update = 2,
    Delete = 3
};


const ChangeLogScheduleTable = (props: Props): JSX.Element => {

    const theme = useTheme();

    let diffs = props.changes;
    let reportChanges: changeLogCategory[] = [];

    //procss the diffs data
    if (diffs) {
        let keys = Object.keys(diffs);
        keys.forEach((key: any) => {
            let category: changeLogCategory = {
                category: key,
                items: diffs[key]
            };
            if(category.items.length > 0){
                reportChanges.push(category);
            }
        });
    }

    const setChangeType = (changeTypeId: number) => {

        let statusColor = '';
        let statusBgColor = '';
        let statusText = '';

        switch (changeTypeId) {
            case ChangeType.Add:
                statusBgColor = alpha(theme.palette.success.light, 0.1);
                statusColor = theme.palette.success.dark;
                statusText = 'Added';
                break;
            case ChangeType.Update:
                statusBgColor = alpha(theme.palette.primary.light, 0.1);
                statusColor = theme.palette.primary.dark;
                statusText = 'Updated';
                break;
            case ChangeType.Delete:
                statusBgColor = alpha(theme.palette.error.light, 0.1);
                statusColor = theme.palette.error.dark;
                statusText = 'Deleted';
                break;
        }

        return (
            <Typography
                variant={'caption'}
                fontWeight={550}
                sx={{
                  bgcolor: `${statusBgColor}`,
                  color: `${statusColor}`,
                  paddingX: 1.5,
                  paddingY: 0.5,
                  borderRadius: 4,
                  display: 'inline',
                }}
              >
              {statusText}
              </Typography>
        );

    }

    return (
        <Grid container spacing={1}>
         <TableContainer component={Paper}>
             <Table aria-label="amended items table" size="small">
                 <TableHead>
                     <TableRow>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Item
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Type
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Changes
                             </Typography>
                         </TableCell>
                     </TableRow>
                 </TableHead>
                 <TableBody>
                     {reportChanges?.map((change: changeLogCategory, index) => (
                        <>
                            <TableRow
                                key={index}
                                sx={{
                                    '&:last-child td, &:last-child th': { border: 0 },
                                 }}
                            >
                             <TableCell>
                                 <Typography variant={'subtitle2'} fontWeight={550} component={'i'}>
                                     {change.category}
                                 </Typography>
                             </TableCell>
                             <TableCell></TableCell>
                             <TableCell></TableCell>
                            </TableRow>
                            {
                                change.items.map((item: ChangeLogItem, index) => (
                                item.resultType !== ChangeType.Unclear &&
                                <TableRow key={index}>
                                    <TableCell>
                                        <Typography variant={'subtitle2'}>
                                            {item.resultDisplayName}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        {setChangeType(item.resultType)}
                                    </TableCell>
                                    <TableCell>
                                        {
                                            !item.childResults ? 
                                            <Typography variant={'subtitle2'}>
                                                {item.resultType === ChangeType.Update ? `${item.oldValue}  →  ${item.newValue}` : ''}
                                            </Typography> : 
                                            <>
                                                {
                                                    item.childResults.map((child: ChangeLogItem, index) => (
                                                        (item.resultType === ChangeType.Update) &&
                                                        <Typography variant={'subtitle2'} key={index}>
                                                            <b>{child.resultDisplayName}</b>: {child.oldValue}   {'→'}  {child.newValue}
                                                        </Typography>
                                                    ))
                                                }
                                            </>
                                        }
                                    </TableCell>
                                </TableRow>
                                ))
                            }   
                        </>
                    ))}
                 </TableBody>
             </Table>
         </TableContainer>
        </Grid>
    );
}

export default ChangeLogScheduleTable;